import { defineStore } from 'pinia';
import api from '@/services/api';

export const useClienteClasificacionStore = defineStore('clienteClasificacionStore', {
  state: () => ({
    clienteClasificacionList: [],
    page: 1,
  }),
  actions: {
    async findAllClienteClasificacionHTTP() {
      const result = await api.get('/cliente-clasificacion', { params: { page: +this.page } });
      if (result && result.data) {
        this.clienteClasificacionList.splice(
          0,
          this.clienteClasificacionList.length,
          ...result.data,
        );
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstClienteClasificacion() {
      this.setPage(1);
      this.emptyList();
      await this.findAllClienteClasificacionHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.clienteClasificacionList = [];
    },
  },
});
